import React from 'react';
import { FsSimpleTableProps } from 'ui-elements/tables/FsSimpleTable/FsSimpleTable';
import FsBodySmallBold from 'ui-elements/typography/FsBodySmallBold';
import defaultLocales from 'globals/locales/default';
import { FsExpenditureTableTransactionRowDataProps } from 'ui-elements/tables/FsExpenditureTable/FsExpenditureTableTransactionRow/FsExpenditureTableTransactionRow';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';

const { amount: amountCaption, date: dateCaption } = defaultLocales;

export const getTableProps = (
  transactions: FsExpenditureTableTransactionRowDataProps[]
): FsSimpleTableProps => ({
  head: [
    {
      id: 0,
      caption: amountCaption,
    },
  ],
  firstRowCaption: dateCaption,
  rows: transactions.map(({ id, date, displayValue }) => ({
    id,
    name: <FsBodySmall>{date}</FsBodySmall>,
    values: [<FsBodySmallBold>{displayValue}</FsBodySmallBold>],
  })),
});

export default {
  getTableProps,
};
